import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { testIds } from "@/constants/testIds";
import { toast } from "sonner";
import { UserPlus, CheckCircle2 } from "lucide-react";

export default function CollabRegister() {
  const { registerCollab } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6)
      return toast.error("Password minimo 6 caratteri");
    setLoading(true);
    try {
      await registerCollab(form);
      setDone(true);
      toast.success("Registrazione inviata!");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore registrazione");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="min-h-[70vh] flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-sm bg-zinc-900/90 border border-emerald-500/30 rounded-2xl p-6 sm:p-8 text-center">
          <div className="w-14 h-14 rounded-full bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center mx-auto mb-4">
            <CheckCircle2 className="text-emerald-400" size={26} />
          </div>
          <h2 className="font-heading text-xl font-black uppercase text-white">
            Registrazione ricevuta
          </h2>
          <p className="text-zinc-400 text-sm mt-2">
            Riceverai una email non appena l'admin Spectrum approverà il tuo
            account. Poi potrai accedere e caricare il tuo materiale.
          </p>
          <Link
            to="/collaboratori"
            className="inline-flex items-center gap-2 mt-6 min-h-[44px] px-5 rounded-lg bg-rose-600 hover:bg-rose-500 text-white font-bold text-sm uppercase tracking-wider transition"
          >
            Torna al login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-10">
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-zinc-900/90 border border-zinc-800 rounded-2xl p-6 sm:p-8 shadow-2xl"
      >
        <div className="w-12 h-12 rounded-xl bg-rose-600/15 border border-rose-500/30 flex items-center justify-center mb-4 mx-auto">
          <UserPlus className="text-rose-500" size={20} />
        </div>
        <h1 className="font-heading text-2xl font-black uppercase text-center text-white">
          Diventa partner
        </h1>
        <p className="text-center text-xs text-zinc-500 mt-1 mb-6 font-mono uppercase tracking-widest">
          Registra il tuo service
        </p>

        <div className="space-y-3">
          <div>
            <label className="block text-[10px] font-mono uppercase tracking-widest text-zinc-500 mb-1">
              Nome service
            </label>
            <input
              data-testid={testIds.collabRegisterName}
              required
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Es. DJ Marco Service"
              className="w-full min-h-[46px] px-4 rounded-lg bg-zinc-950 border border-zinc-800 focus:border-rose-600 focus:outline-none text-white text-sm"
            />
          </div>
          <div>
            <label className="block text-[10px] font-mono uppercase tracking-widest text-zinc-500 mb-1">
              Email
            </label>
            <input
              data-testid={testIds.collabRegisterEmail}
              type="email"
              required
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full min-h-[46px] px-4 rounded-lg bg-zinc-950 border border-zinc-800 focus:border-rose-600 focus:outline-none text-white text-sm"
            />
          </div>
          <div>
            <label className="block text-[10px] font-mono uppercase tracking-widest text-zinc-500 mb-1">
              Telefono
            </label>
            <input
              data-testid={testIds.collabRegisterPhone}
              value={form.phone}
              onChange={(e) => setForm({ ...form, phone: e.target.value })}
              className="w-full min-h-[46px] px-4 rounded-lg bg-zinc-950 border border-zinc-800 focus:border-rose-600 focus:outline-none text-white text-sm"
            />
          </div>
          <div>
            <label className="block text-[10px] font-mono uppercase tracking-widest text-zinc-500 mb-1">
              Password (min. 6 caratteri)
            </label>
            <input
              data-testid={testIds.collabRegisterPassword}
              type="password"
              required
              minLength={6}
              value={form.password}
              onChange={(e) =>
                setForm({ ...form, password: e.target.value })
              }
              className="w-full min-h-[46px] px-4 rounded-lg bg-zinc-950 border border-zinc-800 focus:border-rose-600 focus:outline-none text-white text-sm"
            />
          </div>
        </div>

        <button
          data-testid={testIds.collabRegisterBtn}
          type="submit"
          disabled={loading}
          className="w-full min-h-[48px] mt-6 rounded-lg bg-rose-600 hover:bg-rose-500 disabled:opacity-50 text-white font-heading font-black uppercase tracking-wider text-sm shadow-lg shadow-rose-900/40 transition active:scale-[0.98] flex items-center justify-center gap-2"
        >
          <UserPlus size={16} />
          {loading ? "Invio..." : "Registrati"}
        </button>

        <div className="mt-4 text-center">
          <Link
            to="/collaboratori"
            className="text-xs text-zinc-500 hover:text-rose-400 font-mono uppercase tracking-widest transition"
          >
            Hai già un account? Accedi
          </Link>
        </div>
      </form>
    </div>
  );
}
